import React from "react";
import { STAGES, statusToIndex } from "../lib/theme";

export default function StageRail({ status, view }) {
  const current = view ? statusToIndex(view) : statusToIndex(status);
  return (
    <div className="flex items-center gap-1.5" data-testid="stage-rail">
      {STAGES.map((s) => {
        const done = current > s.n;
        const active = current === s.n;
        return (
          <div key={s.key} className="flex items-center gap-1.5">
            <div
              className={`flex items-center gap-1.5 rounded-full border px-2.5 py-1 font-mono text-[11px] transition-all ${active ? "pulse-soft" : ""}`}
              style={{
                borderColor: done || active ? s.color : "rgba(255,255,255,0.08)",
                background: done ? `${s.color}` : active ? `${s.color}22` : "transparent",
                color: done ? "#0B0D12" : active ? s.color : "#8B93A5",
              }}
              data-testid={`rail-seg-${s.n}`}
            >
              <span className="font-semibold">{s.n}</span>
              <span className="hidden sm:inline">{s.name}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
